var map = {
	"./aim/0.png": "./src/assets/images/aim/0.png",
	"./dog/double/0.png": "./src/assets/images/dog/double/0.png",
	"./dog/find/0.png": "./src/assets/images/dog/find/0.png",
	"./dog/jump/0.png": "./src/assets/images/dog/jump/0.png",
	"./dog/jump/1.png": "./src/assets/images/dog/jump/1.png",
	"./dog/laugh/0.png": "./src/assets/images/dog/laugh/0.png",
	"./dog/laugh/1.png": "./src/assets/images/dog/laugh/1.png",
	"./dog/single/0.png": "./src/assets/images/dog/single/0.png",
	"./dog/sniff/0.png": "./src/assets/images/dog/sniff/0.png",
	"./dog/sniff/1.png": "./src/assets/images/dog/sniff/1.png",
	"./dog/sniff/2.png": "./src/assets/images/dog/sniff/2.png",
	"./dog/sniff/3.png": "./src/assets/images/dog/sniff/3.png",
	"./dog/sniff/4.png": "./src/assets/images/dog/sniff/4.png",
	"./duck/black/dead/0.png": "./src/assets/images/duck/black/dead/0.png",
	"./duck/black/dead/1.png": "./src/assets/images/duck/black/dead/1.png",
	"./duck/black/dead/2.png": "./src/assets/images/duck/black/dead/2.png",
	"./duck/black/left/0.png": "./src/assets/images/duck/black/left/0.png",
	"./duck/black/left/1.png": "./src/assets/images/duck/black/left/1.png",
	"./duck/black/left/2.png": "./src/assets/images/duck/black/left/2.png",
	"./duck/black/right/0.png": "./src/assets/images/duck/black/right/0.png",
	"./duck/black/right/1.png": "./src/assets/images/duck/black/right/1.png",
	"./duck/black/right/2.png": "./src/assets/images/duck/black/right/2.png",
	"./duck/black/shot/0.png": "./src/assets/images/duck/black/shot/0.png",
	"./duck/black/top-left/0.png": "./src/assets/images/duck/black/top-left/0.png",
	"./duck/black/top-left/1.png": "./src/assets/images/duck/black/top-left/1.png",
	"./duck/black/top-left/2.png": "./src/assets/images/duck/black/top-left/2.png",
	"./duck/black/top-right/0.png": "./src/assets/images/duck/black/top-right/0.png",
	"./duck/black/top-right/1.png": "./src/assets/images/duck/black/top-right/1.png",
	"./duck/black/top-right/2.png": "./src/assets/images/duck/black/top-right/2.png",
	"./duck/red/dead/0.png": "./src/assets/images/duck/red/dead/0.png",
	"./duck/red/dead/1.png": "./src/assets/images/duck/red/dead/1.png",
	"./duck/red/dead/2.png": "./src/assets/images/duck/red/dead/2.png",
	"./duck/red/left/0.png": "./src/assets/images/duck/red/left/0.png",
	"./duck/red/left/1.png": "./src/assets/images/duck/red/left/1.png",
	"./duck/red/left/2.png": "./src/assets/images/duck/red/left/2.png",
	"./duck/red/right/0.png": "./src/assets/images/duck/red/right/0.png",
	"./duck/red/right/1.png": "./src/assets/images/duck/red/right/1.png",
	"./duck/red/right/2.png": "./src/assets/images/duck/red/right/2.png",
	"./duck/red/shot/0.png": "./src/assets/images/duck/red/shot/0.png",
	"./duck/red/top-left/0.png": "./src/assets/images/duck/red/top-left/0.png",
	"./duck/red/top-left/1.png": "./src/assets/images/duck/red/top-left/1.png",
	"./duck/red/top-left/2.png": "./src/assets/images/duck/red/top-left/2.png",
	"./duck/red/top-right/0.png": "./src/assets/images/duck/red/top-right/0.png",
	"./duck/red/top-right/1.png": "./src/assets/images/duck/red/top-right/1.png",
	"./duck/red/top-right/2.png": "./src/assets/images/duck/red/top-right/2.png",
	"./hud/bullet/0.png": "./src/assets/images/hud/bullet/0.png",
	"./hud/score-dead/0.png": "./src/assets/images/hud/score-dead/0.png",
	"./hud/score-live/0.png": "./src/assets/images/hud/score-live/0.png",
	"./scene/back/0.png": "./src/assets/images/scene/back/0.png",
	"./scene/tree/0.png": "./src/assets/images/scene/tree/0.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive \\.png$";